/**
 *  DO NOT REMOVE ANYTHING RELATED TO COUNTRY BELOW.
 *  Country as a single data is now deprecated, but may be reverted anytime.
 */

import React from 'react'
import { connect } from 'react-redux'
import ProductActions from '../../Redux/ProductRedux'
import { includes } from 'lodash'
import { currentBranch } from '../../Utils/PrivilegeUtils'
// import CountryList from './CountryList'
// import Select from 'react-select'
// import findKey from 'lodash/findKey'

class UpdateContent extends React.Component {
  constructor (props) {
    super(props)
    // let countries = []
    // props.country_list.map((item, i) => {
    //   countries[i] = {
    //     value: item.id,
    //     label: item.name
    //   }
    //   return countries
    // })
    // this.countries = countries
    // let country_id = props.detail.details ? props.detail.details.country_id : ''
    // const key = findKey(countries, ['value', country_id])

    const currencyCode = (branch = currentBranch()) => {
      switch (branch) {
        case 'ID':
          return 'IDR'
        case 'PH':
          return 'PHP'
        default:
          return null
      }
    }

    this.CCSelector = [
      { value: 'IDR', label: 'IDR', restriction: ['PH'] },
      // { value: 'SGD', label: 'SGD', restriction: ['PH'] },
      { value: 'USD', label: 'USD', restriction: ['PH'] },
      { value: 'PHP', label: 'PHP' }
    ].filter((option) => { return (!includes(option.restriction, currentBranch())) })

    this.state = {
      showModal: null,
      form: {
        title: props.detail.title || '',
        description: props.detail.description || '',
        description_ind: props.detail.description_ind || '',
        description_eng: props.detail.description_eng || '',
        short_desc_id: props.detail.short_desc_id || '',
        short_desc_en: props.detail.short_desc_en || '',
        meta_description: props.detail.meta_description || '',
        meta_title: props.detail.meta_title || '',
        normal_price: props.detail.normal_price || 0,
        price: props.detail.price || 0,
        currency_code: props.detail.currency_code || currencyCode(),
        image_file: props.detail.image_file || '',
        product_type: props.detail.product_type || 'modem',
        status: props.detail.status || 'active',
        divisor: props.detail.divisor || 1,
        use_coupon: props.detail.use_coupon || '1',
        quota: props.detail.quota || '',
        short_code: props.detail.short_code || '',
        iso_code: props.detail.iso_code || currentBranch(),
        details: {
          country_id: props.detail.details ? props.detail.details.country_id : ''
        }
      },
      // country: countries[key] || '',
      file: null,
      uploaded: false
    }
  }

  _inputChange = (event, field) => {
    let val = event.target.value
    // 'deprecate' the validation below
    // if (event.target.type === 'number') {
    //   val = parseInt(val, 10)
    // }
    let form = { ...this.state.form }
    form[field] = val
    this.setState({ form })
  }

  // _countryChange = (country) => {
  //   let form = { ...this.state.form }
  //   form.details.country_id = country.value
  //   this.setState({ country, form })
  // }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    if (currentBranch() === 'PH') {
      form.description_ind = form.description_eng
    }
    const data = { id: this.props.detail.id, form }
    this.props.submit(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <section className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Edit Product Content</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title</label>
            </div>
            <div className='col-9'>
              <input type='text' placeholder='Product Title' className='form-control' value={this.state.form.title} onChange={(event) => this._inputChange(event, 'title')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Key Passpod</label>
            </div>
            <div className='col-9'>
              <textarea placeholder='Key Passpod' className='form-control' value={this.state.form.description} onChange={(event) => this._inputChange(event, 'description')} />
            </div>
          </div>
          {
            currentBranch() !== 'PH' &&
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Description (ID)</label>
              </div>
              <div className='col-9'>
                <textarea placeholder='Indonesian Product Description' className='form-control' value={this.state.form.description_ind} onChange={(event) => this._inputChange(event, 'description_ind')} />
              </div>
            </div>
          }
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Description (EN)</label>
            </div>
            <div className='col-9'>
              <textarea placeholder='English Product Description' className='form-control' value={this.state.form.description_eng} onChange={(event) => this._inputChange(event, 'description_eng')} />
            </div>
          </div>
          {
            currentBranch() !== 'PH' &&
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Short Description (ID)</label>
              </div>
              <div className='col-9'>
                <textarea placeholder='' className='form-control' value={this.state.form.short_desc_id} onChange={(event) => this._inputChange(event, 'short_desc_id')} />
              </div>
            </div>
          }
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Short Description (EN)</label>
            </div>
            <div className='col-9'>
              <textarea placeholder='' className='form-control' value={this.state.form.short_desc_en} onChange={(event) => this._inputChange(event, 'short_desc_en')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Meta-title</label>
            </div>
            <div className='col-9'>
              <textarea placeholder='Meta-title' className='form-control' value={this.state.form.meta_title} onChange={(event) => this._inputChange(event, 'meta_title')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Meta-description</label>
            </div>
            <div className='col-9'>
              <textarea placeholder='Meta-description' className='form-control' value={this.state.form.meta_description} onChange={(event) => this._inputChange(event, 'meta_description')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Currency Code</label>
            </div>
            <div className='col-9'>
              <select className='form-control' value={this.state.form.currency_code} onChange={(event) => this._inputChange(event, 'currency_code')}>
                { this.CCSelector.map((item, i) => <option key={i} value={item.value}>{item.label}</option>) }
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Normal Price</label>
            </div>
            <div className='col-9'>
              <input type='number' min={0} className='form-control' value={this.state.form.normal_price} onChange={(event) => this._inputChange(event, 'normal_price')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Final Price</label>
            </div>
            <div className='col-9'>
              <input type='number' min={0} className='form-control' value={this.state.form.price} onChange={(event) => this._inputChange(event, 'price')} />
            </div>
          </div>
          {/* <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Country</label>
            </div>
            <div className='col-9'>
              <Select options={this.countries} value={this.state.country} onChange={(country) => this._countryChange(country)} />
            </div>
          </div> */}
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Product Type</label>
            </div>
            <div className='col-9'>
              <select className='form-control' value={this.state.form.product_type} onChange={(event) => this._inputChange(event, 'product_type')}>
                <option value='modem'>Modem</option>
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Status</label>
            </div>
            <div className='col-9'>
              <select className='form-control' value={this.state.form.status} onChange={(event) => this._inputChange(event, 'status')}>
                <option value='active'>Active</option>
                <option value='inactive'>Inactive</option>
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Divisor</label>
            </div>
            <div className='col-9'>
              <input type='number' className='form-control' min='1' required value={this.state.form.divisor} onChange={(event) => this._inputChange(event, 'divisor')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Allow Coupon</label>
            </div>
            <div className='col-9'>
              <select className='form-control' required value={this.state.form.use_coupon} onChange={(event) => this._inputChange(event, 'use_coupon')}>
                <option value='1'>Allowed</option>
                <option value='0'>Not Allowed</option>
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Quota</label>
            </div>
            <div className='col-9'>
              <input placeholder='Product quota' type='text' className='form-control' value={this.state.form.quota} onChange={(event) => this._inputChange(event, 'quota')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Short Code</label>
            </div>
            <div className='col-9'>
              <input placeholder='Short product code (3 to 4 letters)' type='text' minLength={3} maxLength={4} className='form-control' value={this.state.form.short_code} onChange={(event) => this._inputChange(event, 'short_code')} />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  submit: (data) => dispatch(ProductActions.productUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateContent)



// WEBPACK FOOTER //
// ./src/Containers/Product/UpdateContent.js